import DrugSearchBar from 'components/Searchbar/drugSearchBar';
import Navbar from 'components/navbar';
import { Outlet, useLocation } from 'react-router-dom';
import { useStore } from 'hooks/useStore';
import { useEffect } from 'react';

const BDPortalHoc = () => {
  const {
    BDPortalStore: { resetStore: resetBDPortalStore },
    LandingPageStore: { resetStore: resetLandingPageStore },
  } = useStore();

  const location = useLocation();

  // Check if the current route is a ProductWiki route
  const isProductWikiRoute = location.pathname.includes('/bdportal/product-wiki');

  useEffect(() => {
    // Cleanup function will be called when component unmounts
    return () => {
      resetBDPortalStore();
      resetLandingPageStore();
    };
  }, [resetBDPortalStore, resetLandingPageStore]);

  return (
    <div>
      <Navbar
        heading={isProductWikiRoute ? 'Product Wiki' : 'BD Tracker'}
        searchComponent={!isProductWikiRoute ? <DrugSearchBar /> : undefined}
      />
      <Outlet />
    </div>
  );
};

export default BDPortalHoc;
